import React from "react"
import { IndicatorContainerProps, components } from "react-select"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTimes } from "@fortawesome/pro-light-svg-icons"
import styles from "../../../Select/Select.module.scss"

const SearchIndicatorsContainer: React.FC<IndicatorContainerProps<{ label: string; value: string }, false>> = props => {
    const { selectProps, children } = props

    const handleClear = (e: React.MouseEvent) => {
        e.stopPropagation()
        e.preventDefault()
        selectProps.onInputChange?.("", { action: "input-change" })
    }

    const clearButton = selectProps.inputValue ? (
        <div className={styles.indicator} onMouseDown={handleClear}>
            <FontAwesomeIcon icon={faTimes} className={styles.indicator__icon} />
        </div>
    ) : null

    // Порядок: [Loading] [Separator] [Clear] [Dropdown]
    // DropdownIndicator всегда последний child — вставляем крестик перед ним
    const childArray = React.Children.toArray(children)
    if (clearButton) {
        childArray.splice(childArray.length - 1, 0, clearButton)
    }

    return <components.IndicatorsContainer {...props}>{childArray}</components.IndicatorsContainer>
}

export default SearchIndicatorsContainer
